const R = 6371000;
const toRad = (deg) => (deg * Math.PI) / 180;

export function calculateDistance(lat1, lon1, lat2, lon2) {
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const sinDLat2 = Math.sin(dLat / 2);
  const sinDLon2 = Math.sin(dLon / 2);
  const a =
    sinDLat2 * sinDLat2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * sinDLon2 * sinDLon2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}
